import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TrackedLink, eitherOr } from '@xingternal/xing-tracking';
import { useMediaListener, BREAKPOINTS } from '@xingternal/util';
import styles from './NotificationCenter.css';
import { IconComponent } from './IconComponent';
import { NotificationCenterButton } from './NotificationCenter.styles';
const NotificationCenter = ({ className, count, notificationCenterWeb: { href, title }, intl: { formatMessage }, }) => {
    const breakpoint = useMediaListener();
    const trackingConditions = {
        sc_o_PropActionOrigin: eitherOr(count),
    };
    const label = formatMessage({
        id: title,
    });
    return (React.createElement(TrackedLink, { trackingKey: "notification_center", conditions: trackingConditions, className: cx(styles.link, className), to: href },
        React.createElement(NotificationCenterButton, { "aria-label": label, children: breakpoint === BREAKPOINTS.handheld ? undefined : label, icon: IconComponent, size: "medium" })));
};
NotificationCenter.propTypes = {
    className: PropTypes.string,
    notificationCenterWeb: PropTypes.shape({
        title: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
    }).isRequired,
    count: PropTypes.number.isRequired,
    intl: PropTypes.object.isRequired,
};
export { NotificationCenter };
//# sourceMappingURL=NotificationCenter.js.map